exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-main[data-v-078753dd] {\r\n  /*50 = navbar  */\r\n  min-height: calc(100vh - 0.66667rem);\r\n  width: 100%;\r\n  position: relative;\r\n  overflow: hidden;\n}\n.fixed-header+.app-main[data-v-078753dd] {\r\n  padding-top: 0.66667rem;\n}\r\n", ""]);

// exports
